import React, { useState } from 'react'
import { RxChevronLeft, RxQuestionMark } from 'react-icons/rx'
import { SlPower } from 'react-icons/sl'
import '../../header.css'
import { Link } from 'react-router-dom'
import LogoutModal from '../logout/LogoutModal'

const Header = () => {
  const [showLogout, setShowLogout] = useState(false)

  const handleShowLogout = () => {
    setShowLogout(true)
  }

  const handleCloseLogout = () => {
    setShowLogout(false)
  }

  return (
    <React.Fragment>
      <div className='app-header'>
        <div className='app-header-content'>
          <div>
            <Link to='/home' className='app-header-menu-btn app-header-btn'>
              <RxChevronLeft />
            </Link>
          </div>
          <div>
            <p>Saving Account</p>
          </div>
          <div>
            <span className='app-header-btn'>
              <RxQuestionMark />
            </span>
            <button className='app-header-btn' onClick={handleShowLogout}>
              <SlPower />
            </button>
          </div>
        </div>
      </div>
      <LogoutModal show={showLogout} onClose={handleCloseLogout} setShowLogout={setShowLogout} />
    </React.Fragment>
  )
}

export default Header